export const FETCH_AVAILABLE_GATEWAYS = "FETCH_AVAILABLE_GATEWAYS";
export const FETCH_AVAILABLE_GATEWAY = "FETCH_AVAILABLE_GATEWAY";
export const CREATE_AVAILABLE_GATEWAY = "CREATE_AVAILABLE_GATEWAY";
export const UPDATE_AVAILABLE_GATEWAY = "UPDATE_AVAILABLE_GATEWAY";
export const DELETE_AVAILABLE_GATEWAY = "DELETE_AVAILABLE_GATEWAY";

export function fetchAvailableGateways(params = {}) {
  params = Object.assign(
    {},
    params
  );
  return {
    type: FETCH_AVAILABLE_GATEWAYS,
    auth: true,
    payload: {
      url: "superuser/available-gateways",
      method: "GET",
      params
    }
  };
}

export function fetchAvailableGateway(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_AVAILABLE_GATEWAY,
    auth: true,
    payload: {
      url: `superuser/available-gateways/${id}`,
      method: "GET",
      params
    }
  };
}

export function createAvailableGateway(data = {}) {
  return {
    type: CREATE_AVAILABLE_GATEWAY,
    auth: true,
    payload: { 
      url: "superuser/available-gateways",
      method: "POST",
      data
    }
  };
}

export function updateAvailableGateway(id, data = {}) {
  return {
    type: UPDATE_AVAILABLE_GATEWAY,
    auth: true,
    payload: {
      url: `superuser/available-gateways/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteAvailableGateway(id, data = {}) {
  return {
    type: DELETE_AVAILABLE_GATEWAY,
    auth: true,
    payload: {
      url: `superuser/available-gateways/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/availableGateway.js